module.exports = new __parcel__URL__("hi-tom_12.f5d60938.mp3").toString();